import { render, staticRenderFns } from "./EditTeacher.vue?vue&type=template&id=0a53b62f&scoped=true"
import script from "./EditTeacher.vue?vue&type=script&lang=js"
export * from "./EditTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a53b62f",
  null
  
)

export default component.exports